import { createRouter, createWebHistory } from "vue-router";
import {
  canAccessConsoleRoute,
  parseStoredConsoleProfile,
  profileMatchesConsoleDomain,
} from "@/access-control";
import {
  consoleRouterBase,
  consoleStorageKey,
  detectConsoleDomain,
} from "@/console-domain";

export const router = createRouter({
  history: createWebHistory(consoleRouterBase()),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/LoginView.vue"),
    },
    {
      path: "/",
      name: "dashboard",
      component: () => import("@/views/DashboardView.vue"),
      meta: { auth: true },
    },
    {
      path: "/operations",
      name: "operations",
      component: () => import("@/views/OperationsView.vue"),
      meta: { auth: true },
    },
    {
      path: "/chat-moderation",
      name: "chat-moderation",
      component: () => import("@/views/ChatModerationView.vue"),
      meta: { auth: true },
    },
    {
      path: "/users",
      name: "users",
      component: () => import("@/views/UsersAdminView.vue"),
      meta: { auth: true },
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () => import("@/views/NotificationsView.vue"),
      meta: { auth: true },
    },
    {
      path: "/admin-accounts",
      name: "admin-accounts",
      component: () => import("@/views/AdminAccountsView.vue"),
      meta: { auth: true },
    },
    {
      path: "/matches",
      name: "matches-admin",
      component: () => import("@/views/MatchesAdminView.vue"),
      meta: { auth: true },
    },
    {
      path: "/data-center",
      name: "data-center",
      component: () => import("@/views/DataCenterView.vue"),
      meta: { auth: true },
    },
    {
      path: "/system-settings",
      name: "system-settings",
      component: () => import("@/views/SystemSettingsView.vue"),
      meta: { auth: true },
    },
    {
      path: "/payment-settings",
      name: "payment-settings",
      component: () => import("@/views/PaymentSettingsView.vue"),
      meta: { auth: true },
    },
    {
      path: "/app-settings",
      name: "app-settings",
      component: () => import("@/views/AppSettingsView.vue"),
      meta: { auth: true },
    },
    {
      path: "/kyc",
      name: "kyc",
      component: () => import("@/views/KycView.vue"),
      meta: { auth: true },
    },
    {
      path: "/withdrawals",
      name: "withdrawals",
      component: () => import("@/views/WithdrawalsView.vue"),
      meta: { auth: true },
    },
    {
      path: "/approvals",
      name: "approvals",
      component: () => import("@/views/ApprovalsView.vue"),
      meta: { auth: true },
    },
    {
      path: "/audit",
      name: "audit",
      component: () => import("@/views/AuditView.vue"),
      meta: { auth: true },
    },
    {
      path: "/release-readiness",
      name: "release-readiness",
      component: () => import("@/views/ReleaseReadinessView.vue"),
      meta: { auth: true },
    },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});

router.beforeEach((to) => {
  if (!to.meta.auth) return true;

  const tokenKey = consoleStorageKey("accessToken");
  const profileKey = consoleStorageKey("profile");
  if (!sessionStorage.getItem(tokenKey)) return { name: "login" };

  const domain = detectConsoleDomain();
  const profile = parseStoredConsoleProfile(sessionStorage.getItem(profileKey));
  if (!profile || !profileMatchesConsoleDomain(profile, domain)) {
    sessionStorage.removeItem(tokenKey);
    sessionStorage.removeItem(profileKey);
    return { name: "login", query: { reason: "session" } };
  }

  if (!canAccessConsoleRoute(to.path, domain, profile.permissions)) {
    return { name: "dashboard", query: { denied: "1" } };
  }
  return true;
});
